// extracted by mini-css-extract-plugin
export default {"confirm":"CreateBidForm_confirm__n23k5"};